<template>
  <div class="fill-account">
    <van-nav-bar
      title="填写账号信息"
      left-arrow
      fixed
      placeholder
      @click-left="$router.go(-1)"
    />

    <div class="main">
      <div class="zz">
        <div class="head">
          <p class="title">资质信息</p>
          <p class="tips">
            请仔细核对资质信息，若有误，请前往<span>资质中心</span>修改
          </p>
        </div>
        <div class="form-content">
          <van-field
            v-model="form.realName"
            label="姓名"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.idNumber"
            label="身份证号"
            label-width="120"
            readonly
          />
          <van-field
            v-if="accountType == 2"
            v-model="form.idCardVid"
            label="身份证有效期"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.idCardFront"
            :formatter="formatter"
            label="法人身份证头像面"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.idCardBack"
            :formatter="formatter"
            label="法人身份证国徽面"
            label-width="120"
            readonly
          />
        </div>
      </div>
      <div class="bk">
        <div class="head">
          <p class="title">绑卡信息</p>
          <p class="tips">请绑定入驻人名下的个人银行卡</p>
        </div>
        <div class="form-content">
          <van-field
            v-model="form.realName"
            label="开户名"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.bankCardNum"
            label="银行卡号"
            label-width="120"
            placeholder="请输入银行卡号"
          />
          <van-field
            v-model="form.khh"
            label="开户行"
            label-width="120"
            placeholder="请选择"
            readonly
            clickable
            is-link
            @click="showPicker = true"
          />
          <van-field
            v-model="form.bankAddress"
            label="银行地址"
            label-width="120"
            placeholder="省/市"
            readonly
            clickable
            is-link
            @click="showAddressPicker = true"
          />
          <van-field
            v-model="form.khzh"
            label="开户支行"
            label-width="120"
            placeholder="请选择"
            readonly
            clickable
            is-link
            @click="showZhPicker = true"
          />
          <template v-if="accountType == 1">
            <van-field
              v-model="form.bankMobile"
              label="银行预留手机"
              label-width="120"
              placeholder="请输入银行预留手机号"
              maxlength="11"
            />
            <van-field
              v-model="form.contactsMobile"
              label="联系人手机号"
              label-width="120"
              placeholder="请输入联系人手机号"
              maxlength="11"
            />
          </template>
        </div>
      </div>

      <div class="autoDeduction" v-if="accountType == 1">
        <van-cell center title="是否签约授权扣款">
          <template #right-icon>
            <van-switch
              v-model="form.autoDeduction"
              size="22"
              active-color="#4ae4b0"
              disabled
            />
          </template>
        </van-cell>
      </div>

      <div class="super-administrator" v-else>
        <div class="head">
          <p class="title">超级管理员信息</p>
          <p class="tips">
            超级管理员需在后续流程中使用实名认证的微信扫码完成签约，确保所填信息与微信实名信息一致，如不方便可填写财务相关人员信息
          </p>
        </div>
        <div class="form-content">
          <van-field
            v-model="form.realName"
            label="姓名"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.idNumber"
            label="身份证号"
            label-width="120"
            readonly
          />
          <van-field
            v-model="form.wxMobile"
            label="手机号"
            label-width="120"
            placeholder="输入入驻人手机号"
            maxlength="11"
          />
          <van-field
            v-model="form.email"
            label="邮箱"
            label-width="120"
            placeholder="输入入驻人邮箱"
          />
        </div>
      </div>
    </div>

    <div class="bottom">
      <template v-if="accountType == 1">
        <van-checkbox v-model="agree" checked-color="#ee0a24" icon-size="18px">
          <p style="font-size: 12px; color: #909399">
            我已仔细已阅读并同意
            <span style="color: #3235dd">《和众账户服务协议》</span>、<span
              style="color: #3235dd"
              >《支付宝协议》</span
            >开通聚合账户，将同步开通支付宝账户、合众账户
          </p>
        </van-checkbox>

        <p style="margin-top: 10px; font-size: 12px; color: #909399">
          为规范平台合作的支付服务机构在平台治理流程您提供的受托转账服务，保障您的权益，您需要和支付服务机构武汉合众易宝科技有限公司签署此<span
            style="color: #3235dd"
            >授权扣款协议</span
          >
        </p>
      </template>

      <div class="special" v-else>
        <p class="title">特殊资质信息</p>
        <p class="tips">
          当您的营业执照包含特殊行业时，请提供为”申请商家主体“所属的特殊资质，可授权使用总公司/分公司的特殊资质
        </p>
        <p style="color: #3235dd; font-size: 12px">查看说明</p>
        <p class="tips">最多可提供5张，请确保每张资质有效期不少于90天</p>

        <van-uploader
          v-model="fileList"
          multiple
          :max-count="5"
          :after-read="afterRead"
          :preview-options="{ closeable: true }"
          style="margin-top: 5px"
        />
      </div>

      <div class="btn" :class="{ disabled }" @click="handleSubmit">提交</div>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="khhList"
        @confirm="(val) => onConfirm(val, 'khh')"
        @cancel="showPicker = false"
      />
    </van-popup>

    <van-popup v-model="showAddressPicker" position="bottom">
      <van-area
        title="所在地区"
        :area-list="areaList"
        :columns-num="2"
        @confirm="(val) => onConfirm(val, 'bankAddress')"
        @cancel="showAddressPicker = false"
      />
    </van-popup>

    <van-popup v-model="showZhPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="khzhList"
        @confirm="(val) => onConfirm(val, 'khzh')"
        @cancel="showZhPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { areaList } from "@vant/area-data";
import {
  NavBar,
  Field,
  Popup,
  Picker,
  Area,
  Cell,
  Switch,
  Checkbox,
  Dialog,
  Uploader,
} from "vant";
export default {
  props: {
    form: Object,
  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Cell.name]: Cell,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      areaList,
      showPicker: false,
      khhList: ["中国银行", "中国农业银行", "中国工商银行", "中国建设银行"],
      showAddressPicker: false,
      khzhList: ["中国银行厦门分行"],
      showZhPicker: false,
      agree: false,
      fileList: [],
    };
  },
  computed: {
    disabled() {
      if (this.accountType == 1)
        return (
          !this.form.bankCardNum ||
          !this.form.khh ||
          !this.form.bankAddress ||
          !this.form.khzh ||
          !this.form.bankMobile ||
          !this.form.contactsMobile ||
          !this.agree
        );
      else
        return (
          !this.form.bankCardNum ||
          !this.form.khh ||
          !this.form.bankAddress ||
          !this.form.khzh ||
          !this.form.wxMobile ||
          !this.form.email
        );
    },
    accountType() {
      return this.$route.query.type;
    },
  },
  methods: {
    formatter(value) {
      return value ? "已上传" : "未上传";
    },
    onConfirm(value, str) {
      if (str == "bankAddress") {
        this.form[str] = value[0].name + " " + value[1].name;
      } else this.form[str] = value;
      this.showPicker = false;
      this.showAddressPicker = false;
      this.showZhPicker = false;
    },
    handleSubmit() {
      if (this.disabled) return;
      Dialog.confirm({
        message: "提交后进入审核状态，确认继续？",
        messageAlign: "left",
        width: "280px",
        className: "confirm-dialog",
        confirmButtonColor: "#000",
        confirmButtonText: "提交",
        cancelButtonColor: "#606266",
        getContainer: () => {
          return document.querySelector(".fill-account");
        },
      })
        .then(() => {
          if (this.accountType == 1) this.form.haveJh = true;
          else this.form.haveWx = true;
          if (this.form.haveJh && this.form.haveWx) this.$emit("onSubmit");
          this.$router.go(-1);
        })
        .catch(() => {
          // on cancel
        });
    },
    afterRead(file) {
      console.log(file);
    },
  },
};
</script>

<style lang="less" scoped>
.fill-account {
  .main {
    .zz,
    .bk,
    .super-administrator {
      margin-bottom: 10px;
      padding: 0 10px;
      background-color: #fff;
      span {
        color: #3235dd;
      }
    }
    .head {
      padding-bottom: 10px;
      border-bottom: solid 1px #ebeef5;
      .title {
        padding: 10px 0;
      }
      .tips {
        font-size: 12px;
        color: #909399;
      }
    }
    .form-content {
      ::v-deep  .van-field {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
  .bottom {
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    .title {
      margin-bottom: 5px;
    }
    .tips {
      font-size: 12px;
      color: #909399;
    }
    .btn {
      margin-top: 10px;
      padding: 10px 0;
      text-align: center;
      color: #fff;
      background-color: #e21e48;
      border-radius: 3px;
      cursor: pointer;
      &.disabled {
        opacity: 0.4;
        background-color: #909399;
        cursor: not-allowed;
      }
    }
  }
  ::v-deep .confirm-dialog {
    border-radius: 0;
  }
}
</style>